export const CHAT_FRAME_COMMANDS = {
  increaseHeight: {fullHeight: true},
  decreaseHeight: {fullHeight: false},
}
